import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d20f81e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=0d20f81e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20f81e",
  null
  
)

export default component.exports